import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsDistribution,
  useMetricsPatterns,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsFilters,
  MetricsPatternsParams,
} from "../../../../../shared/api/types";

export const useRecoveryStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || [
      "recovery_score",
      "resting_heart_rate",
      "hrv",
      "sleep_performance",
    ],
  });
};

export const useRecoveryTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || [
      "recovery_score",
      "resting_heart_rate",
      "hrv",
      "sleep_performance",
    ],
    granularity: params?.granularity || "daily",
  });
};

export const useRecoveryScoreDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "recovery_score",
  });
};

export const useHeartRatePatterns = (params: MetricsPatternsParams) => {
  return useMetricsPatterns({
    ...params,
    metric: "heart_rate_patterns",
  });
};

